/**
 * API Client for PIRT Triage Dashboard.
 *
 * Auth is temporarily disabled (Midway allowlist pending).
 * Once enabled, all API requests will include the Midway JWT via authFetch.
 */

// Midway OIDC auth is enabled — Federate profile approved
const AUTH_ENABLED = true;

const API_BASE = "/api";

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string
  ) {
    super(message);
    this.name = "ApiError";
  }
}

async function apiFetch<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  let response: Response;

  if (AUTH_ENABLED) {
    const { authFetch } = await import("../auth");
    response = await authFetch(`${API_BASE}${path}`, options);
  } else {
    response = await fetch(`${API_BASE}${path}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  if (!response.ok) {
    const text = await response.text().catch(() => "Unknown error");
    throw new ApiError(response.status, text);
  }

  return response.json();
}

export { apiFetch };

// Local storage for triage state (decision log, notes, waiting-on)
export const localStore = {
  get<T>(key: string, fallback: T): T {
    try {
      const stored = localStorage.getItem(`pirt:${key}`);
      return stored ? JSON.parse(stored) : fallback;
    } catch {
      return fallback;
    }
  },
  set<T>(key: string, value: T): void {
    localStorage.setItem(`pirt:${key}`, JSON.stringify(value));
  },
};
